<script setup>
import { ref, computed, onMounted } from "vue";
import budgetsModal from "@/components/modal/budgets-modal.vue";
import { useBudgetRevenueStore } from "@/stores/budgetRevenueStore";

const title = ref("Budgets Revenue");
const text = ref("HR");
const text1 = ref("Budgets Revenue");


const revenueStore = useBudgetRevenueStore();
const budgetModalRef = ref(null);

const columns = [
  { sorter: false },
  {
    title: "Revenue Name",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Category Name",
    dataIndex: "category_name",
    key: "category_name",
  },
  {
    title: "Sub Category Name",
    dataIndex: "sub_category_name",
    key: "sub_category_name",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Budget",
    dataIndex: "budget_title",
    key: "budget_title",
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const pagination = computed(() => ({
  total: revenueStore.meta.total,
  current: revenueStore.meta.current_page,
  pageSize: revenueStore.meta.per_page,
  showSizeChanger: false,
}));

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function handleTableChange(pager) {
  revenueStore.fetch({ page: pager.current });
}

function onSearch() {
  revenueStore.fetch({ page: 1 });
}

function openAddRevenue() {
  budgetModalRef.value?.openCreate();
}

function openEdit(record) {
  if (!record?.budget_id) return;
  budgetModalRef.value?.openEdit({ id: record.budget_id });
}

async function deleteRevenue(record) {
  if (!record?.id) return;
  if (!window.confirm("Delete this revenue item?")) return;
  await revenueStore.remove(record.id);
}

onMounted(() => {
  revenueStore.fetch();
});
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <!-- <div class="mb-2">
            <button
              type="button"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddRevenue"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Revenue
            </button>
          </div> -->
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Budgets Revenue list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Budget Revenue List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-2">
              <input
                type="text"
                class="form-control"
                placeholder="Search revenue..."
                v-model="revenueStore.filters.q"
                @keyup.enter="onSearch"
              />
            </div>
            <button class="btn btn-sm btn-white" @click="onSearch">
              <i class="ti ti-search me-1"></i>Search
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="revenueStore.items"
              :row-selection="rowSelection"
              :loading="revenueStore.loading"
              :pagination="pagination"
              @change="handleTableChange"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'title'">
                  <h6 class="fw-medium mb-0">
                    <a href="javascript:void(0);">{{ record.title }}</a>
                  </h6>
                  <small class="text-muted" v-if="record.budget_title">
                    Budget: {{ record.budget_title }}
                  </small>
                </template>

                <template v-else-if="column.key === 'amount'">
                  {{ Number(record.amount || 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) }}
                </template>

                <!-- <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      @click.prevent="openEdit(record)"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      @click.prevent="deleteRevenue(record)"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template> -->
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Budgets Revenue list -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <!-- Reuse the main budget modal -->
  <budgets-modal ref="budgetModalRef" />
</template>


